<template>
  <!-- 门禁智能系统解决方案 -->
  <div class="content_app">
    <Banner :banner-h="h1" :banner-p="P1" :banner-img="Img1"></Banner>
    <scroll-animate>
      <div class="system_service_introduced">
        <img src="@/assets/img/service/access/access3.png">
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="product_hardware">
        <h1>{{ $t('services.smartLockers.productHardware') }}</h1>
        <p>{{ $t('services.smartLockers.productHardwareDesc') }}</p>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="involved_products">
        <h1>{{ $t('services.smartLockers.involvedProducts') }}</h1>
        <section class="disp-content core_box">
          <ul class="content_ul">
            <li v-for="(item, index) in deviceData" :key="index">
            <span class="content-img">
              <img :src="item.image">
            </span>
              <h3>
                {{ $t(`services.smartLockers.devices.${item.key}.title`) }}
              </h3>
              <p>{{ $t(`services.smartLockers.devices.${item.key}.description`) }}</p>
              <span class="span_jiantou el-icon-right" @click="deviceItemClick(item)">
            </span>
              <em></em>
              <em></em>
            </li>
          </ul>
        </section>
      </div>
    </scroll-animate>

  </div>

</template>

<script>
import Banner from "@/components/banner.vue";
import {entranceGuard} from "@/assets/js/entranceGuard";
import {displayCase} from "@/assets/js/displayCase";
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  mounted() {
  },
  methods: {
    deviceItemClick(data) {

      let productsData = null
      switch (data.category) {
        case "displayCase":
          productsData = displayCase
          break
        case "entranceGuard":
          productsData = entranceGuard
          break
      }

      if (productsData) {
        for (const item of productsData) {
          if (item.categoryName == data.dataKey) {
            const categoryData = {name: item.categoryName}
            categoryData.options = []
            item.catgItem.forEach((it) => {
              categoryData.options.push(it)
            })
            sessionStorage.setItem("product", JSON.stringify(categoryData))
            this.$router.push({
              name: "productShow",
            })
            break
          }
        }
      }
    }
  },
  data() {
    return {
      h1: this.$t('services.smartLockers.title'),
      P1: this.$t('services.smartLockers.description'),
      Img1: require("@/assets/img/banner-bg/shanmai1.jpg"),

      // 设备架构数据
      deviceData: [
        {
          image: require("@/assets/img/service/access/dianzisuo.png"),
          dataKey: this.$t('displayCase.categoryName.electronicLock'),
          key: "miniatureLock",
          category: "displayCase"
        },
        {
          image: require("@/assets/img/service/access/cwg_dukaqi.png"),
          dataKey: this.$t('displayCase.categoryName.cardReader'),
          key: "cardReader",
          category: "displayCase"
        },
        {
          image: require("@/assets/img/service/access/cwg_zhuanyong_kongzhiqi.png"),
          dataKey: this.$t('displayCase.categoryName.controller'),
          key: "specialController",
          category: "displayCase"
        },
        {
          image: require("@/assets/img/service/access/cwg_jichengdianyuan.png"),
          dataKey: this.$t('displayCase.categoryName.powerSupply'),
          key: "integratedPowerSupply",
          category: "displayCase"
        }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/css/serviceCommonCss";
</style>
